export const SALES_PHONE = '9845504930';
export const SUPPORT_PHONE = '8722557733';
export const SALES_EMAIL = 'digitaldongre@gmail.com';
export const SUPPORT_EMAIL = 'support@iissms.co.in';
export const LEGAL_SUPPORT_EMAIL = 'support@iissms.com';
const WHATSAPP_PREFILL = 'Namaste, Pls share details about WhatsApp Business API. Thank You.';
export const WHATSAPP_URL = `https://api.whatsapp.com/send/?phone=91${SALES_PHONE}&text=${encodeURIComponent(WHATSAPP_PREFILL)}`;
export const COMPANY_ADDRESS =
  '25, 1st Floor, 1st Main, 2nd Stage, E Block, Rajajinagara, Bengaluru - 10';
export const FACEBOOK_URL = 'https://www.facebook.com/iissmsindia';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/iisashok/';
export const YOUTUBE_URL = 'https://www.youtube.com/@iissmsindia';
